import type {
  PassContent,
  PassContentValue,
  TemplateField,
} from '../../../../store/types/pass';

export const extractFieldValue = (
  value: PassContentValue | undefined
): string => {
  if (!value) return '';
  if (typeof value === 'object' && 'value' in value) return value.value || '';
  return typeof value === 'string' ? value : '';
};

export const resolveValue = (
  field: TemplateField,
  passContent?: PassContent
): string => {
  if (!field.id) return field.default_value || '';
  if (passContent) {
    const key = Object.keys(passContent).find(
      (k) =>
        k.toLowerCase().replace(/\s/g, '') ===
        field.id.toLowerCase().replace(/\s/g, '')
    );
    if (key) {
      const val = extractFieldValue(passContent[key]);
      if (val) return val;
    }
  }
  return field.default_value || '';
};
